import { NgModule } from "@angular/core";
import { ExcelService } from "./excel.service";

@NgModule({
  providers: [ExcelService],
})
export class ExcelModule {}
